import { ICategory, ICategoryType, IHobby, ISkill, ISubject } from '@wot/typings';
import xhr from '../utils/fetch';
import { SubjectCategory, SubjectDTO } from '../interfaces/curriculum';

export interface CategoryReqBody {
  type: 'subject' | 'hobby' | 'skill';
  category: ISubject | IHobby | ISkill;
}

export interface PCategoryUpdateReqBody {
  _id: string;
  data: {
    category: ISubject | IHobby | ISkill;
  };
}

export interface AddNewSubjectReqBody {
  categoryId: string;
  subject: SubjectDTO;
}

const addCategories = async (categories: CategoryReqBody[]) => {
  return await xhr({
    url: `/a/categories`,
    method: 'POST',
    body: categories
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const updateCategory = async (data: PCategoryUpdateReqBody) => {
  return await xhr({
    url: `/a/categories`,
    method: 'PUT',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getCategories = async (type: ICategoryType): Promise<ICategory<ISubject & IHobby & ISkill>[]> => {
  return await xhr({
    url: `/categories?type=${type}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getCategoryById = async (_id: string) => {
  return await xhr({
    url: `/categories/${_id}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getSubjectCategory = async () => {
  return await xhr({
    url: `/s/getAllCategories`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const addSubjectCategory = async (data: SubjectCategory) => {
  return await xhr({
    url: `/s/addCategory`,
    method: 'POST',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const addNewSubject = async (data: AddNewSubjectReqBody) => {
  return await xhr({
    url: `/s/addSubject`,
    method: 'POST',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getSubjectById = async (id: string): Promise<any> => {
  return await xhr({
    url: `/s/getSubject/${id}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const updateSubject = async (id: string, data: any): Promise<any> => {
  return await xhr({
    url: `/s/updateSubject/${id}`,
    method: 'PUT',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const categoryApi = {
  addCategories,
  getCategories,
  getCategoryById,
  updateCategory,
  getSubjectCategory,
  addSubjectCategory,
  addNewSubject,
  getSubjectById,
  updateSubject
};

export default categoryApi;
